module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXRewardsTank/components/WGCWXRewardsTankConfirmation/images/alert_light.fdac27de.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/components/WGCWXRewardsTankConfirmation/images/alert_light.png
// module id = 1052
// module chunks = 16